import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: () => import('./InspectionDeclaration')
        },
        {
            path: '/devicelist',
            component: () => import('./DeviceList')
        },
        {
            path: '/applyinspection',
            component: () => import('./ApplyInspection')
        },
        {
            path: '/form-list/:phone',
            component: () => import('./InspectionFormList')
        },
        {
            path: '/form-detail/:id',
            name: 'detail',
            component: () => import('./InspectionFormDetail')
        },
        {
            path: '/charge-form-list/:phone',
            component: () => import('./ChargeFormList')
        },
        {
            path: '/charge-form-detail/:id',
            component: () => import('./ChargeFormDetail')
        },
        {
            path: '/charge-bill-pdf-view/:id/:deviceKindCode',
            component: () => import('./ChargeBillPdfView')
        }
    ]
})
